import { computed, Ref, ref } from "vue";
import { SyainService } from "@/service/SyainService";
import { DetailInputData } from "@/types/Syain";
import { useRoute } from "vue-router";

/*
 * 初期処理
 */
export function useInit() {
  const route = useRoute()
  const userId = parseInt(route.params.id as string, 10)
  const koyouKeiyakuId = parseInt(route.params.koyou_id as string, 10)
  const loading = ref(2) // APIで読み込みをする本数
  const isError = ref(false)
  const isEdit = ref(userId ? true : false)
  const kinmuStatus:Ref<number | null> = ref(null)
  const staffCode:Ref<number | null> = ref(null)
  const options = ref()
  const form: Ref<DetailInputData> = ref({
    user_id: null,
    staff_code: null,
    staff_name: null,
    staff_kana: null,
    gender_type: 1,
    birthday_date: null,
    address: null,
    zip_code: null,
    email: null,
    tel: null,
    keitai_tel: null,
    emergency_name: null,
    emergency_tel: null,
    is_drivers_license: false,
    drivers_license: null,
    hokensyou_no: null,
    is_web_meisai: false,
    kinmu_status: null,
    notes: null,
    koyou_hoken: null,
    nenkin_bangou: null,
    web_mitaiou_notes: null,
    last_logined_at: null,
    nyuusya_date: null,
    yuukyuu_reference_date: null,
    taisyoku_date: null,
    kinmu_status_type: null,
    last_available_day: null,
    tenpufiles: null,
    user_teates: [],
    sonota_kyuujitus: [],
    mst_yakusyoku_id: null,
    mst_role_id: null,
    shikaku_notes: null,
    idoureki_notes: null,
    koyou_keiyaku_notes: null,
    mst_syozoku_id: null,
    // DetailInputData
    role_name: null,
    is_force_logout: false,
    has_yuukyuu_fuyu: false,
  })

  const srv = new SyainService();

  // 社員情報取得
  if (isEdit.value) {
    // 修正
    srv.getInfoForUpdate(userId, koyouKeiyakuId).then((res: DetailInputData) => {
      if (Object.keys(res).length < 1) {
        // エラー
        isError.value = true
      }
      kinmuStatus.value = res.kinmu_status_type
      staffCode.value = res.staff_code
      form.value = res;
      loading.value--;
    })
  } else {
    // 新規登録
    loading.value--;
  }

  // 必要なオプション類を取得する
  srv.getAllOptions().then(opt => {
    if (Object.keys(opt).length < 1) {
      // エラー
      isError.value = true;
    }
    options.value = opt;
    loading.value--;
  });

  // 読み込み中か判断する
  const isLoading = computed(() => {
    return !(loading.value === 0 || isError.value)
  })

  return {
    form,
    isLoading,
    isError,
    isEdit,
    kinmuStatus,
    staffCode,
    options,
  }
}
